import React, { ReactNode } from 'react';

import { GlyphContainer, ImageContainer, NameContainer } from './Glyph.style';

export interface GlyphType {
  name: string;
  glyph: ReactNode;
  textColor?: string;
}

export const Glyph = ({ content }: { content: GlyphType }) => {
  const { name, glyph, textColor } = content;

  return (
    <GlyphContainer>
      <ImageContainer>{glyph}</ImageContainer>
      <NameContainer textColor={textColor}>{name}</NameContainer>
    </GlyphContainer>
  );
};
